// @flow
import { useMemo } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';
import KpiService from '../../services/kpiService';

const DEFAULT_FILTER_OPTIONS = {
  certificationType: [],
  certStatus: [],
  propertyName: [],
  complianceDocumentType: [],
  programType: [],
  complianceApprovalStatus: [],
};

const useComplianceOverviewFilterOptionsQuery = ({
  organizationId,
  includeNotStartedCerts,
  options,
}: {
  organizationId: string,
  includeNotStartedCerts?: boolean,
  options?: UseQueryOptions,
}) => {
  const isQueryEnabled = options?.enabled ?? true;

  const { data, isLoading } = useQuery(
    [
      'useComplianceOverviewFilterOptionsQuery',
      organizationId,
      includeNotStartedCerts,
    ],
    async ({ signal } = {}) => {
      const requestOptions = signal ? { signal } : undefined;
      return new KpiService().getComplianceOverviewFilterOptions(
        organizationId,
        includeNotStartedCerts,
        requestOptions,
      );
    },
    {
      enabled: Boolean(organizationId && isQueryEnabled),
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: false,
      ...options,
    },
  );

  const filterOptions = useMemo(() => data ?? DEFAULT_FILTER_OPTIONS, [data]);

  return {
    filterOptions,
    isLoading,
  };
};

export default useComplianceOverviewFilterOptionsQuery;
